import React, { useState } from "react";

/**
 * Intake Step — raw text dump → AI prefill of the configurator.
 *
 * The user pastes notes / mails / call protocols. We send to Claude which
 * conservatively extracts only what is in the text (never invents). The
 * configurator then opens with those fields prefilled and visually marked.
 */
const IntakeStep = ({
  onPrepare,
  onSkip,
  isPreparing,
  initialText = "",
  lastFilledFields = null,
}) => {
  const [text, setText] = useState(initialText);

  const charCount = text.trim().length;
  const canSubmit = charCount >= 20 && !isPreparing;

  return (
    <div className="vbo-intake">
      <div className="vbo-intake__hero">
        <div className="vbo-intake__eyebrow">Schritt 1 — optional</div>
        <h1 className="vbo-intake__title">Teile deine Informationen</h1>
        <p className="vbo-intake__sub">
          Wirf hier alles rein, was Du über den Kunden weißt - Call-Notizen,
          E-Mail-Verläufe, Briefing, Protokolle, Zitate. BonusClub Intelligence
          extrahiert vorsichtig, was belegbar ist, und füllt damit den
          Konfigurator vor. Erfunden wird nichts - Lücken siehst Du im nächsten
          Schritt klar.
        </p>
      </div>

      <div className="vbo-intake__card">
        <textarea
          className="vbo-intake__textarea"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={'Beispiel: "Acme Solutions GmbH (acme-solutions.de) bietet B2B-SaaS für Lager-Management. Erstgespräch mit GF Max Mustermann ergab: das Marketing-Team ist klein und schafft es nicht, proaktiv Leads zu generieren. Ein Neukunde bringt ca. 12.000€/Jahr MRR. Spirit war neugierig und offen, ein paar Detailfragen offen. Wichtig: wöchentliche Updates und Custom Lead-Scraping. Branche stark umkämpft, aber das Produkt ist im Workflow-Bereich überdurchschnittlich differenziert ..."'}
          spellCheck
          rows={14}
        />

        <div className="vbo-intake__meta">
          <span className={charCount < 20 ? "vbo-intake__meta--warn" : ""}>
            {charCount} Zeichen{charCount < 20 ? " · mind. 20 nötig" : ""}
          </span>
          {lastFilledFields && (
            <span className="vbo-intake__meta-tag">
              Letzte Extraktion: {lastFilledFields.length} Felder befüllt
            </span>
          )}
        </div>

        <div className="vbo-intake__actions">
          <button
            type="button"
            className="vbo-intake__btn vbo-intake__btn--ghost"
            onClick={onSkip}
            disabled={isPreparing}
          >
            Überspringen — Konfigurator manuell ausfüllen
          </button>
          <button
            type="button"
            className="vbo-intake__btn vbo-intake__btn--primary"
            onClick={() => onPrepare(text)}
            disabled={!canSubmit}
          >
            {isPreparing ? (
              <>
                <span className="vbo-intake__spinner" /> BonusClub Intelligence extrahiert …
              </>
            ) : (
              <>Aufbereiten &amp; in Konfigurator übernehmen</>
            )}
          </button>
        </div>
      </div>

      <div className="vbo-intake__hints">
        <div className="vbo-intake__hint">
          <strong>Was BonusClub Intelligence extrahieren kann:</strong> Firma, Ansprechpartner,
          Website, aktuelle Situation, Ziele, bisheriger Verlauf, Umsatz/Abschluss,
          Kunden-Spirit, ausgewählte Prioritäten und (falls klar im Text)
          die vier Score-Felder.
        </div>
        <div className="vbo-intake__hint">
          <strong>Was nicht passiert:</strong> Felder ohne klare Evidenz bleiben
          leer — kein Halluzinieren. Du füllst sie manuell nach.
        </div>
      </div>
    </div>
  );
};

export default IntakeStep;
